export * from "./birthday.component";
